export const maxInvoiceLength = 50
export const maxItemQty = 200
export const minItemQty = 1
export const minItemPrice = 0
export const minDepositPaid = 0
export const maxSubLineCount = 100
export const maxContactsCount = 15
export const minContactsCount = 1
